import React, { useState, useEffect } from "react";
import * as Actions from "../../redux/actions/";
import HeroBanner from "../../components/home/HeroBanner";
import SearchSection from "../../components/home/SearchSection";
import CategoryGrid from "../../components/home/CategoryGrid";
import FeaturedCarousel from "../../components/home/FeaturedCarousel";
import RecentListings from "../../components/home/RecentListings";
import AdBanner from "../../components/home/AdBanner";
import ServiceHighlights from "../../components/home/ServiceHighlights";
import { Box } from "@mui/material";
import { connect } from "react-redux";
import axios from "axios";
import config from "../../config";
import { useLocation } from "react-router-dom";
import FacebookEmail from "../../components/home/FacebookEmail";
import { Spinner } from "../../components/spinner/Spinner";

const HomePage = ({
  user,
  getSeller,
  classes,
  productListings,
  loadListings,
  setUserIsSubscribed,
}) => {
  const [featuredListings, setFeaturedListings] = useState([]);
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const [adData, setAdData] = useState([]);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const paramValue = queryParams.get("success");

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  useEffect(() => {
    if (paramValue === "true") {
      setUserIsSubscribed();
    }
  }, [paramValue]);

  useEffect(() => {
    if (user) {
      const tempEmail = user.email.split("_");
      if (tempEmail[0] === "temp") {
        setEmailModalOpen(true);
      }
    }
  }, [user]);

  const fetchAd = async () => {
    try {
      const response = await axios.get(
        `${config.SERVER_URL}/api/v1/ads?status=active&page=home`,
        { headers: { "Content-Type": "application/json" } }
      );
      if (response.status === 200) {
        setAdData(response.data.data);
      }
    } catch (err) {
      // Non-critical — ads may not exist
    }
  };

  useEffect(() => {
    if (user?.id) {
      getSeller();
    }
  }, [user?.id]);

  useEffect(() => {
    loadListings({
      pageNumber: 0,
      rowsPerPage: 12,
      isFeatured: true,
    });
  }, [loadListings]);

  useEffect(() => {
    setFeaturedListings(productListings.slice(0, 12));
  }, [productListings]);

  useEffect(() => {
    fetchAd();
  }, []);

  return (
    <>
      {classes.length === 0 && <Spinner />}
      <FacebookEmail
        open={emailModalOpen}
        handleClose={() => setEmailModalOpen(false)}
        setEmailModalOpen={setEmailModalOpen}
      />

      <HeroBanner />
      <SearchSection />
      <CategoryGrid />
      <FeaturedCarousel listings={featuredListings} />
      {adData.length > 0 && <AdBanner adData={adData} position={0} />}
      <RecentListings />
      <ServiceHighlights />
      {adData.length > 1 && <AdBanner adData={adData} position={1} />}
    </>
  );
};

const mapStateToProps = ({ Auth, Categories, Listings }) => ({
  user: Auth.user,
  classes: Categories.classes,
  productListings: Listings.listings,
});

const mapDispatchToProps = (dispatch) => ({
  getSeller: () => dispatch(Actions.thunkGetSeller()),
  loadListings: ({ pageNumber, rowsPerPage, isFeatured }) =>
    dispatch(
      Actions.thunkLoadListing({
        pageNumber,
        rowsPerPage,
        isFeatured,
      })
    ),
  setUserIsSubscribed: () => dispatch(Actions.setUserIsSubscribed()),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
